/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bool, func, shape } from "prop-types";

import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";
import { withMultipleSignaturesContext } from "pages/transactions/MultipleSignaturesTables/MultipleSignaturesDataContext";
import { getAccountInfo } from "middleware/accounts";
import * as i18n from "util/i18n";

import { Tag } from "@ui-kit/components/index.es";

import I18n from "pages/_components/I18n";
import FormattedAmount from "pages/_components/FormattedAmount";
import CardContainer from "pages/_components/Card/CardContainer";
import Card from "pages/_components/Card/Card";
import PageLoading from "pages/_components/PageLoading";

const getFirstNotBlank = (...values) => values.find((value) => typeof value === "string" && value.trim().length > 0);

const getBeneficiaryName = (data = {}) => {
    const transactionData = data.transactionData || {};
    return getFirstNotBlank(
        transactionData.beneficiaryName,
        transactionData.nombreBeneficiario,
        data.beneficiaryName,
        data.nombreBeneficiario,
    );
};

const getQuantityAndCurrency = (object) => {
    const amounts = object.transactionAmounts || {};
    const keys = Object.keys(amounts);
    if (keys.length > 0) {
        const currency = keys[0];
        return { currency, quantity: Number(amounts[currency]) || 0 };
    }
    const d = object.transaction?.data || {};
    const nestedAmount = d.amount && typeof d.amount === "object" ? d.amount : null;
    if (nestedAmount !== null && nestedAmount.quantity !== undefined && nestedAmount.quantity !== null) {
        return {
            currency: String(nestedAmount.currency ?? "0"),
            quantity: Number(nestedAmount.quantity) || 0,
        };
    }
    return { currency: "0", quantity: 0 };
};

class SendExternalTransactionDataTable extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        loading: bool,
        multipleSignaturesData: shape({}).isRequired,
    };

    static defaultProps = {
        loading: false,
    };

    state = {
        body: null,
    };

    componentDidMount = () => {
        this.tableBody();
    };

    tableBody = () => {
        const { multipleSignaturesData } = this.props;
        const { selectedTransactionRows } = multipleSignaturesData;

        const bodyPromises = selectedTransactionRows.map((object, i) => {
            const { debitAccount } = object.transaction.data;
            return this.accountInfo(debitAccount, i === selectedTransactionRows.length - 1);
        });

        Promise.all(bodyPromises).then((values) => {
            this.setState({
                body: selectedTransactionRows.map((object, index) => this.renderRow(object, values[index])),
            });
        });
    };

    getActivityLabel = (idActivityOriginal) => {
        if (!idActivityOriginal || String(idActivityOriginal).trim() === "") {
            return "";
        }
        const key = `activity.${idActivityOriginal}`;
        return i18n.get(key, idActivityOriginal);
    };

    renderRow = (object, accountLabel) => {
        const { isDesktop } = this.props;
        const { transaction } = object;
        const { idTransaction, data = {}, submitDateTimeAsString } = transaction;
        const beneficiary = getBeneficiaryName(data);
        const activityLabel = this.getActivityLabel(data.idActivityOriginal);
        const showActivityTag = activityLabel !== "";
        const { currency, quantity } = getQuantityAndCurrency(object);

        const content = (
            <div className="send-external-transaction-card__motivo-row">
                <div className="send-external-transaction-card__first-line">
                    <span className="send-external-transaction-card__beneficiary-block">
                        <span className="send-external-transaction-card__label">
                            <I18n id="multipleSignatures.sendExternal.beneficiaryLabel" />
                        </span>
                        <span className="send-external-transaction-card__value">{beneficiary}</span>
                    </span>
                    {showActivityTag && (
                        <Tag variant="info" className="send-external-transaction-card__activity-tag">
                            <I18n id="multipleSignatures.sendExternal.transactionTypeTagPrefix" /> {activityLabel}
                        </Tag>
                    )}
                </div>
                <div className="send-external-transaction-card__second-line">
                    <span className="send-external-transaction-card__label">
                        <I18n id="multipleSignatures.sendExternal.debitAccountLabel" />
                    </span>
                    <span className="send-external-transaction-card__value">{accountLabel}</span>
                </div>
            </div>
        );

        return (
            <CardContainer key={idTransaction} className="confirmation__cards-container mt-0">
                <Card
                    isDesktop={isDesktop}
                    className="confirmation__cards send-external-transaction-card"
                    icon={isDesktop && "images/transfer-PENDING.svg"}
                    iconClass="card__pending-transaction-icon"
                    hrClass="d-none"
                    title={
                        !isDesktop && (
                            <div>
                                {submitDateTimeAsString && (
                                    <div className="confirmation-cards__title">
                                        <div className="confirmation-cards__title-data">
                                            <I18n id="forms.transaction.ticket.date" />
                                        </div>
                                        <div className="confirmation-cards__title-info">
                                            <span>{submitDateTimeAsString}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    }
                    content={isDesktop ? content : <div>{content}</div>}
                    rightContent={
                        <div className="confirmation-cards__right">
                            <div className="confirmation-cards__right-data">
                                <FormattedAmount currency={currency} quantity={quantity} />
                            </div>
                        </div>
                    }
                />
            </CardContainer>
        );
    };

    accountInfo = async (debit, lastFetch) => {
        const { dispatch } = this.props;
        dispatch(transactionsActions.setLoading(true));
        const responseDebit = await getAccountInfo(debit);
        if (lastFetch) {
            dispatch(transactionsActions.setLoading(false));
        }

        const accountDebit = responseDebit.data.data.account;

        return accountDebit.number.concat(
            " ",
            accountDebit.productType,
            " ",
            i18n.get(`currency.label.${accountDebit.currency}`),
        );
    };

    render() {
        const { loading } = this.props;
        const { body } = this.state;
        return (
            <PageLoading loading={loading} className="min-height-40vh">
                {body}
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    multipleSignaturesData: transactionsSelectors.getMultipleSignaturesData(state),
    loading: transactionsSelectors.getFetching(state),
});

export default connect(mapStateToProps)(withMultipleSignaturesContext(SendExternalTransactionDataTable));
